<template>
  <div id="algorithm">
    <div class="bn-wrap">
      <div class="inner">
        <h3 class="tit">Membership Training</h3>
        <p class="sub">MADSCIENTERZ’ 멤버쉽 트레이닝</p>
        <p class="exp">
          전문 투자자의 투자 노하우를 쉽고 빠르게
        </p>
      </div>
    </div>

    <div class="inner">
      <ul class="prd-list">
        <MemberShipTrainingCard
            title="싸부"
            sub-title="확률에 기반한 알고리즘 트레이딩"
            code="ssabu"
            user-count="312"
            :tags="['퀀트','비트맨 전문가 칼럼', '트레이딩뷰 TOP Author']"
        ></MemberShipTrainingCard>
        <MemberShipTrainingCard
            title="질주"
            sub-title="원칙을 지키는 트레이딩"
            code="zilzu"
            user-count="112"
            :tags="['퀀트','비트맨 전문가 칼럼']"
        ></MemberShipTrainingCard>
        <MemberShipTrainingCard
            :is-blur=true
        ></MemberShipTrainingCard>
        <MemberShipTrainingCard
            :is-blur=true
        ></MemberShipTrainingCard>
      </ul>
    </div>
  </div>
</template>

<script>
import MemberShipTrainingCard from "../components/MemberShipTrainingCard";

export default {
  name: "Algorithms",
  components: {MemberShipTrainingCard}
}
</script>

<style>
@import '~@/assets/css/main.css';
@import '~@/assets/css/reset.css';
@import '~@/assets/css/content.css';
</style>

